var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.dash.allEntitiesLoaded || this.$route.meta.authRequired === false || this.$route.name === 'setup')?_c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }